'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.featuredCategoriesSelector = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reselect = require('reselect');

var _about = require('./about');

var _home = require('./home');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// reducer
var DEFAULT_STATE = {
    categories: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var categories = void 0;

    switch (action.type) {
        case _about.LOAD_ABOUT_DATA_SUCCESS:
        case _home.LOAD_HOME_DATA_SUCCESS:
            // categories
            if (action.payload.categories) {
                categories = action.payload.categories.map(function (x) {
                    // in the case that we're passed the full url, remove the part we dont need.
                    var link = x.link || '';
                    link = link.replace('https://www.liveauctioneers.com', '').replace('http://www.liveauctioneers.com', '');
                    // add in the label until the api returns it
                    return (0, _extends3.default)({
                        label: x.title
                    }, x, {
                        link: link
                    });
                });
            } else {
                categories = [];
            }
            return (0, _extends3.default)({}, state, {
                categories: categories
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.featuredCategories;
};

var featuredCategoriesSelector = exports.featuredCategoriesSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.categories;
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/featuredCategories.js
// module id = fYjc
// module chunks = 60